import { useMemo } from "react";
import { useNotificationContext } from "providers/NotificationProvider";
import { useUnreadConversationsCount } from "views/inbox/api/use-unread-conversations-count";
import { NavItemId } from "./constants";
import { useRentReportingNavCount } from "./use-rent-reporting-nav-count";

const MAX_BADGE_COUNT = 99;

export const formatNavBadgeCount = (count: number) =>
  count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(count);

export const useNavItemCounts = ({
  isInboxEnabled
}: {
  isInboxEnabled: boolean;
}) => {
  const { totalUnread } = useNotificationContext();
  const { unreadConversations } = useUnreadConversationsCount(isInboxEnabled);
  const rentReportingCount = useRentReportingNavCount();

  return useMemo(
    () =>
      new Map<NavItemId, number>([
        [NavItemId.NOTIFICATIONS, totalUnread],
        [NavItemId.INBOX, unreadConversations],
        [NavItemId.RENT_REPORTING, rentReportingCount]
      ]),
    [totalUnread, unreadConversations, rentReportingCount]
  );
};
